module.exports = __webpack_public_path__ + "static/media/buy_interview_6.9e3e05f5.jpg";